import SashiDo from 'lib/SashiDo';
import React, { Component } from 'react';
import history from 'dashboard/history';
import Icon from 'components/Icon/Icon.react';
import Tooltip from 'react-autotip';

import styles from './ProgressPie.scss';


export default class ProgressPie extends Component {
  constructor() {
    super();
    this.state = {
      currentPods: 0,
    };
  }

  async componentDidMount() {
    clearInterval(this._server_check_interval);
    this.startServerChekcInterval();

    this.setState({
      currentPods: this.props.currentSetup.min,
    });
  }

  componentWillReceiveProps() {
    if (this._server_check_interval) {
      clearInterval(this._server_check_interval);
      this.startServerChekcInterval();
    }
  }

  shouldComponentUpdate(nextProps) {
    if (!nextProps && this.props === nextProps) {
      return false;
    }

    return true;
  }

  componentWillUnmount() {
    if (this._server_check_interval) {
      clearInterval(this._server_check_interval);
    }
  }

  startServerChekcInterval() {
    if (this._server_check_interval) {
      clearInterval(this._server_check_interval);
      this._server_check_interval = null;
    }

    this._server_check_interval = setInterval(async () => {
      const { engineScalingConfig, currentApp } = this.props;
      const containerCurrentDeployment = await SashiDo.containerCurrentDeployment({ appId: currentApp.id });
      const deploymentId = containerCurrentDeployment.deployment.objectId;

      const { count } = await SashiDo.containerCurrentPods({
        deploymentId,
      });

      if (count) {
        this.setState({
          currentPods: Math.max(engineScalingConfig.min, count),
        });
      }
    }, 3000);
  }

  scale = (options) => {
    const { onScale } = this.props;

    onScale(options);
  }

  handleUp = () => {
    const {
      currentSetup,
      scalingType,
      engineScalingConfig,
    } = this.props;

    let newMin;
    let newMax;

    if (scalingType === 'fixed') {
      newMin = currentSetup.min + 1;
      newMax = engineScalingConfig.max;
    } else {
      let buffer = engineScalingConfig.buffer;
      if (buffer >= 0) {
        buffer = engineScalingConfig.buffer;
      }

      newMin = currentSetup.min + 1;
      newMax = currentSetup.min + 1 + buffer;
    }

    if (!currentSetup.autoscaling) {
      newMax = newMin;
    }

    this.scale({
      newMin,
      newMax,
    });
  }

  handleDown = () => {
    const {
      currentSetup,
      scalingType,
      engineScalingConfig,
    } = this.props;

    let newMin;
    let newMax;

    if (scalingType === 'fixed') {
      newMin = currentSetup.min - 1;
      newMax = engineScalingConfig.max;
    } else {
      let buffer = engineScalingConfig.buffer;
      if (buffer >= 0) {
        buffer = engineScalingConfig.buffer;
      }
      newMin = currentSetup.min - 1;
      newMax = (currentSetup.min - 1) + buffer;
    }

    if (!currentSetup.autoscaling) {
      newMax = newMin;
    }

    this.scale({
      newMin,
      newMax,
    });
  }

  render() {
    const {
      currentPods,
    } = this.state;

    const {
      currentSetup,
      scalingType,
      engineScalingConfig,
    } = this.props;

    if (!scalingType || !engineScalingConfig) {
      return null;
    }

    const percentage = Math.floor((currentSetup.min / currentSetup.max) * 100);
    const percentageCurrent = Math.floor((currentPods / currentSetup.max) * 100);

    let disableScaleMin = currentSetup.min <= 1;
    if (currentSetup.highAvailability) {
      disableScaleMin = currentSetup.min <= 3;
    }

    let disableScaleMax;
    if (scalingType === 'fixed') {
      disableScaleMax = currentSetup.min >= engineScalingConfig.max;
    } else {
      /* eslint-disable rule */
      if (currentSetup.autoscaling) {
        disableScaleMax = currentSetup.min + engineScalingConfig.buffer >= engineScalingConfig.max;
      } else {
        disableScaleMax = currentSetup.min >= engineScalingConfig.max;
      }
      /* eslint-enable rule */
    }

    return (
      <div className={[styles.radial, currentSetup.highAvailability ? styles.highAvailability : '', currentPods > currentSetup.min ? styles.activateOrange : ''].join(' ')}>
        <div className={styles.radialProgressBarWrapper}>

          <svg className={styles.svg} viewBox="0 0 128 112" width="160" height="140">
            <path className={styles.radialProgressBackground} d="M27.7,104.5C16.1,94.4,8.7,79.4,8.7,62.8C8.7,32.2,33.5,7.4,64,7.4s55.3,24.8,55.3,55.3 c0,16.7-7.4,31.7-19.1,41.8" />
            <path className={[styles.radialProgressBar, styles.current].join(' ')} stroke="url(#gradient)" data-percent={percentageCurrent} d="M27.7,104.5C16.1,94.4,8.7,79.4,8.7,62.8C8.7,32.2,33.5,7.4,64,7.4s55.3,24.8,55.3,55.3 c0,16.7-7.4,31.7-19.1,41.8" />
            <path className={[styles.radialProgressBar, styles.minEngines].join(' ')} data-percent={percentage} d="M27.7,104.5C16.1,94.4,8.7,79.4,8.7,62.8C8.7,32.2,33.5,7.4,64,7.4s55.3,24.8,55.3,55.3 c0,16.7-7.4,31.7-19.1,41.8" />
          </svg>

          {
            currentSetup.highAvailability &&
              <svg className={styles.haText} viewBox="0 0 128 112">
                <defs>
                  <path id="circlePath" d="M27.7,104.5C16.1,94.4,8.7,79.4,8.7,62.8C8.7,32.2,33.5,7.4,64,7.4s55.3,24.8,55.3,55.3 c0,16.7-7.4,31.7-19.1,41.8" />
                </defs>
                <text>
                  <textPath xlinkHref="#circlePath">High Availability</textPath>
                </text>
              </svg>
          }

          <div className={[styles.minmax, styles.min, styles.show].join(' ')}>
            <Tooltip
              text="Control redundancy levels of your app by choosing a minimum number of available engines."
              tooltipStyles={{
                color: '#fff',
                fontFamily: 'Ubuntu',
                fontSize: 14,
                fontWeigt: 300,
                borderRadius: 4,
                maxWidth: 500,
                width: 340,
                unit: 4,
                lightgrey: '#222933',
                opaqueGrey: '#222933',
              }}>
              <span>{currentSetup.min}</span>
            </Tooltip>
          </div>

          <div className={[
            styles.minmax,
            styles.max,
            styles.show,
            !currentSetup.autoscaling && currentSetup.min === currentSetup.max ? styles.blue : '',
            !currentSetup.autoscaling && currentSetup.highAvailability ? styles.green : '',
            ].join(' ')}>
            <Tooltip
              text="The maximum number of the engines is managed by SashiDo's system for security reasons and abuse prevention. Limits can be increased upon request."
              tooltipStyles={{
                color: '#fff',
                fontFamily: 'Ubuntu',
                fontSize: 14,
                fontWeigt: 300,
                borderRadius: 4,
                maxWidth: 500,
                width: 340,
                unit: 4,
                lightgrey: '#222933',
                opaqueGrey: '#222933',
              }}>
              <span>{currentSetup.max}</span>
            </Tooltip>
          </div>

          <div className={styles.containers}>active engine{currentPods > 1 ? 's' : ''}</div>

          <div
            className={styles.radialProgressContainers}
            onClick={() => history.push(`/products/apps/${this.props.currentApp.slug}/metrics/engine`)} >
            {currentPods}
          </div>

        </div>

        {
          !this.props.disabled
            ?
              <div className={styles.controls}>
                <button onClick={this.handleUp} className={[disableScaleMax ? styles.disabled : ''].join(' ')}>
                  <Icon name="arrow-up" width={22} height={22} />
                </button>
                <button onClick={this.handleDown} className={[disableScaleMin ? styles.disabled : ''].join(' ')}>
                  <Icon name="arrow-down" width={22} height={22} />
                </button>
              </div>
            : null
        }
      </div>
    );
  }
}
